import React from 'react';
import { Link } from 'react-router-dom';
import Best_1 from '../../../assets/images/home_page_2/best-sellers/01.png';
import Best_2 from '../../../assets/images/home_page_2/best-sellers/02.png';
import Best_3 from '../../../assets/images/home_page_2/best-sellers/03.png';
import Best_4 from '../../../assets/images/home_page_2/best-sellers/04.png';
import Best_5 from '../../../assets/images/home_page_2/best-sellers/05.png';
import Best_6 from '../../../assets/images/home_page_2/best-sellers/06.png';
import Best_7 from '../../../assets/images/home_page_2/best-sellers/07.png';
import Best_8 from '../../../assets/images/home_page_2/best-sellers/08.png';
import Best_9 from '../../../assets/images/home_page_2/best-sellers/09.png';
import Best_10 from '../../../assets/images/home_page_2/best-sellers/10.png';
import Best_11 from '../../../assets/images/home_page_2/best-sellers/11.png';

const products = [
    { id: 1, image: Best_1, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 2, image: Best_2, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 3, image: Best_3, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 4, image: Best_4, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 5, image: Best_5, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 6, image: Best_6, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 7, image: Best_7, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
    { id: 8, image: Best_8, title: 'Rattan Clothes Basket', price: '$1420', category: 'Decor Art' },
];

const listProducts = [
    { id: 9, image: Best_9, title: 'Shopping Basket Made of Ceramics', discount: '20% OFF' },
    { id: 10, image: Best_10, title: 'Shopping Basket Made of Ceramics', discount: '20% OFF' },
    { id: 11, image: Best_11, title: 'Shopping Basket Made of Ceramics', discount: '20% OFF' },
];

const BestSeller = () => {
    return (
        <section id="best-sellers" className="best-sellers-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="best-seller-product-block">
                            <div className="section">
                                <h2 className="section-title cormorant-font">Best Sellers</h2>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    {products.slice(0, 4).map(product => (
                                        <div key={product.id} className="seller-product-block">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-4">
                                                    <div className="seller-product-img">
                                                        <Link to="#" title="">
                                                            <img src={product.image} className="img-fluid" alt="" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-8">
                                                    <div className="seller-product-dtls">
                                                        <p>{product.category}</p>
                                                        <h5 className="seller-product-title">
                                                            <Link to="#" title="">
                                                                {product.title}
                                                            </Link>
                                                        </h5>
                                                        <p>{product.price}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    {products.slice(4).map(product => (
                                        <div key={product.id} className="seller-product-block">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-4 col-4">
                                                    <div className="seller-product-img">
                                                        <Link to="#" title="">
                                                            <img src={product.image} className="img-fluid" alt="" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="col-lg-8 col-md-8 col-8">
                                                    <div className="seller-product-dtls">
                                                        <p>{product.category}</p>
                                                        <h5 className="seller-product-title">
                                                            <Link to="#" title="">
                                                                {product.title}
                                                            </Link>
                                                        </h5>
                                                        <p>{product.price}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="best-sellers-product-list-block">
                            {listProducts.map(product => (
                                <div key={product.id} className="seller-product-list-block">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4">
                                            <div className="seller-product-list-img">
                                                <Link to="#" title="">
                                                    <img src={product.image} className="img-fluid" alt="" />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-8">
                                            <div className="seller-product-list-dtls">
                                                <h3 className="seller-product-list-title">
                                                    <Link to="#" title="">
                                                        {product.title}
                                                    </Link>
                                                </h3>
                                                <p>{product.discount}</p>
                                                <Link to="#" title="" className="btn btn-secondary-second">
                                                    Shop Now <i className="flaticon-arrow-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BestSeller;